import React from 'react';
import PropTypes from 'prop-types';
import DocumentTitle from 'react-document-title';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { get, isEqual, toLower } from 'lodash';
import { loadSurveys, loadSurveysFilters } from '../actions';
import { loadAsqSurveysCSVReport } from 'actions/asq';
import { loadFollowUpSurveysCSVReport } from 'actions/followup';
import { resetErrorMessage } from 'actions/internal';
import TopNavBar from './nav/TopNavBar';
import ASQSurveysContainer from './asqs/ASQSurveysContainer';
import ASQFilterContainer from './asqs/ASQFilterContainer';
import SubNavBar from './nav/SubNavBar';
import { restoreScrollPosition } from 'utils/scrollHelpers';

class ASQSurveysPage extends React.Component {
  componentDidMount() {
    this.props.resetErrorMessage({ source: 'init', status: false });
    this.props.loadSurveysFilters({ source: 'init' });
    this.props.loadSurveys(this.props.history.location.search, { source: 'init' });
    this.props.loadAsqSurveysCSVReport(0);
    this.props.loadFollowUpSurveysCSVReport(0);
    restoreScrollPosition(get(this.props.location, 'state.scroll', null));
  }

  componentDidUpdate(prevProps) {
    const isFromNavBar = get(this.props.location, 'state.from') === 'navbar' && get(prevProps.location, 'state.from') !== 'navbar';
    if (isFromNavBar || (!isEqual(prevProps.location, this.props.location) && toLower(this.props.history.action) === 'pop')) {
      window.scrollTo(0, 0);
      this.props.loadSurveys(this.props.history.location.search, { source: 'init' });
    }
  }

  render() {
    const { auth } = this.props;
    if (!auth.isAuthChecked) return null;
    return (
      <DocumentTitle title={this.props.t('asq.pageTitle')}>
        <div>
          <TopNavBar />
          <SubNavBar />
          <div className='row'>
            <div className="column">
              <ASQFilterContainer />
              <ASQSurveysContainer />
            </div>
          </div>
        </div>
      </DocumentTitle>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    auth: state.auth,
  }
}

ASQSurveysPage.propTypes = {
  auth: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
  loadSurveys: PropTypes.func.isRequired,
  loadSurveysFilters: PropTypes.func.isRequired,
  loadAsqSurveysCSVReport: PropTypes.func.isRequired,
  loadFollowUpSurveysCSVReport: PropTypes.func.isRequired,
  resetErrorMessage: PropTypes.func.isRequired,
}

export default connect(mapStateToProps, { loadSurveys, loadSurveysFilters, loadAsqSurveysCSVReport, loadFollowUpSurveysCSVReport, resetErrorMessage })(withTranslation()(ASQSurveysPage));
